<form [formGroup]="credentialsForm" (ngSubmit)="solicitarCambioPass()">
  <div>
    <app-mensajes [code]="code" [titulo]="titulo" [detalle]="detalle"></app-mensajes>
    <div class="register-photo" style="background-color:rgb(255,255,255);">
      <div class="form-container">
        <div class="image-holder">
          <img src="assets/img/DNM/logo_20.png" class="top-img">
        </div>
        <div class="form" style="align-self: center!important;">
          <h2 style="text-align: center;"><strong>Reinicio de contraseña</strong></h2>
          <div class="input-group ">
            <p style="text-align: justify; margin-bottom: 0px">Escribe el correo electrónico que utilizas para ingresar al sistema para que podamos enviarte al correo electrónico una contraseña temporal con la que podrás ingresar.</p>
          </div>
          <div class="input-wrapper" style="margin-bottom: 1rem;">
            <input type="email" required formControlName="correo" id="correo"
            autocomplete="off" autofocus placeholder="Correo electrónico" pInputText
            class="ui-inputtext ui-widget">
            <span *ngIf="credentialsForm.get('correo').hasError('pattern')">
                <p-message severity="error" text="Verifique el correo electrónico ingresado"></p-message>
            </span>
          </div>
          <div class="input-wrapper">
            <button style="background-color: #313945; border: #0D1175;" type="submit" label="Solicitar contraseña" pButton [disabled]="!credentialsForm.valid"></button>
          </div>
        </div>
      </div>
    </div>
    <app-spinner [visible]="visibleSpinner"></app-spinner>
  </div>
</form>
